"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Filters = _interopRequireDefault(require("../../models/transform/filter/Filters"));

var _isEmpty = _interopRequireDefault(require("../../utils/array/isEmpty"));

var _isNotNil = _interopRequireDefault(require("../../utils/object/isNotNil"));

var _creative = require("../../constants/creative");

var combineParentAndChildFilters = function combineParentAndChildFilters(parentFilters, childFilters) {
  var hasChildFilters = (0, _isNotNil["default"])(childFilters) && !(0, _isEmpty["default"])(childFilters.filters);
  var hasParentFilters = (0, _isNotNil["default"])(parentFilters) && !(0, _isEmpty["default"])(parentFilters.filters);
  if (!hasChildFilters && !hasParentFilters) return _creative.DEFAULT_KEYFRAME_TRANSFORM.filters; // if child is undefined but parent is defined

  if (!hasChildFilters && hasParentFilters) {
    return parentFilters;
  } // if parent is undefined but child is defined


  if (hasChildFilters && !hasParentFilters) {
    return childFilters;
  }

  var child = _Filters["default"].fromJSON(childFilters);

  var parent = _Filters["default"].fromJSON(parentFilters);

  var combined = _Filters["default"].combine(parent, child);

  return combined.toJSON();
};

var _default = combineParentAndChildFilters;
exports["default"] = _default;